import { render, staticRenderFns } from "./AdditionalDataCard.vue?vue&type=template&id=d0e07eae&scoped=true&"
import script from "./AdditionalDataCard.vue?vue&type=script&lang=js&"
export * from "./AdditionalDataCard.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalDataCard.vue?vue&type=style&index=0&id=d0e07eae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e07eae",
  null
  
)

export default component.exports